import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 3l-4 4l4 4","key":"svg-0"}],["path",{"d":"M3 7h11a3 3 0 0 1 3 3v11","key":"svg-1"}],["path",{"d":"M13 17l4 4l4 -4","key":"svg-2"}]]

const IconArrowsLeftDown = createReactComponent('outline', 'arrows-left-down', 'ArrowsLeftDown', __iconNode);

export default IconArrowsLeftDown;